'use client';

import { useEffect, useState } from "react";
import { SlideOutNewsletter } from "@/app/lib/generated/graphql-types";
import { loadNewsletterFlyoutContent } from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/data-access/preload";
import FlyoutWrapper from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutWrapper";
import { Stack, Typography } from "@mui/material";
import FlyoutHeaderTypography
    from "@/app/features/sites/header/ui/desktop/flyout-info/FlyoutHeaderTypography";
import { Markdown } from "@/app/features/shared/markdown/Markdown";
import NewsletterRegisterDialog
    from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/ui/newsletter/NewsletterRegisterDialog";
import NewsletterUnregisterDialog
    from "@/app/features/sites/header/ui/desktop/flyout-info/flyouts/ui/newsletter/NewsletterUnregisterDialog";
import ErrorBox from "@/app/__to_be_integrated/_____components/_NEW/ErrorBox";

export default function NewsletterFlyoutInfo() {
    const [content, setContent] = useState<SlideOutNewsletter>();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        (async () => {
            const { data, error } = await loadNewsletterFlyoutContent();
            if (error || !data) {
                console.error('Error loading newsletter flyout content:', error);
                setError('Fehler beim Laden der Inhalte. Bitte versuchen Sie es später erneut.');
                return;
            }

            setContent(data);
        })()
    }, []);

    if (error) return <ErrorBox error={error} />
    if (content === undefined) return null;

    return (
        <FlyoutWrapper
            hideBackgroundOnMobile={false}
            backgroundImage={content.image}
            fit="fit"
            contentSide="right"
        >
            <Stack
                className="text-center overscroll-none md:text-left md:max-w-[25vw] py-4"
                spacing={2}
                justifyContent="space-between"
            >
                <Stack spacing={2}>
                    <FlyoutHeaderTypography>{content.title}</FlyoutHeaderTypography>
                    <Typography variant="subtitle1">{content.subtitle}</Typography>
                    <Markdown value={content.description}  />
                </Stack>
                <Stack spacing={2}>
                    <NewsletterRegisterDialog />
                    <NewsletterUnregisterDialog />
                </Stack>
            </Stack>
        </FlyoutWrapper>
    )
}
